import {Loader} from 'semantic-ui-react';
import styled from 'styled-components';

export const VariantLoader = styled(Loader)`
  && {
    position: relative;
  }
`;
